// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3pMhY{width:100%;text-align:center}.ZtZDD{background-size:cover;width:100%;height:473px;cursor:pointer}", ""]);
// Exports
exports.locals = {
	"root": "_3pMhY",
	"slide": "ZtZDD"
};
module.exports = exports;
